import React from 'react';
import PropTypes from 'prop-types';

const IconFilled = ({ icon, percentage, subtitle, offset, fillClasses }) => (
  <div className="icon-filled-container d-flex flex-column align-items-center justify-content-center">
    <div className={`icon-filled d-flex align-items-end justify-content-center ${fillClasses}`}>
      {percentage > 0 ? (
        <>
          <div className="waves">
            <div className="wave" style={{ bottom: `calc(${percentage - offset}%)` }} />
            <div className="wave" style={{ bottom: `calc(${percentage - offset}%)` }} />
          </div>
          <div className="charge" style={{ height: `calc(${percentage - offset}%)` }} />
        </>
      ) : null}
      {icon}
    </div>
    <div className="icon-filled-subtitle">{subtitle}</div>
  </div>
);

IconFilled.propTypes = {
  icon: PropTypes.node.isRequired,
  percentage: PropTypes.number,
  subtitle: PropTypes.node,
  offset: PropTypes.number,
  fillClasses: PropTypes.string,
};

IconFilled.defaultProps = {
  percentage: undefined,
  subtitle: '',
  fillClasses: '',
  offset: 0,
};

export default IconFilled;
